// extracted by mini-css-extract-plugin
module.exports = {"container":"_1c81de7c","form_horizon":"_10dc0ea7","label":"_5e7c9942","form_container":"_a51f45bb","buttons":"_a13855c9"};